import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setContent } from '../../../../../../../Redux/slices/certificate';

import TextOffCanvas from '../../../molecules/OffCanvas/TextOffCanvas/TextOffCanvas';

/**
 *
 */
function Content({ preview }) {
  const content = useSelector((state) => state.certificate.content);
  const { text, color, fontSize, alignment } = content;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = (contentValue) => {
    dispatch(setContent(contentValue));
  };

  return (
    <>
      {preview && (
        <div
          style={{
            fontSize: `${fontSize}px`,
            color: color,
            textAlign: alignment,
            width: '100%'
          }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
      {!preview && (
        <>
          <div
            className={`${preview ? '' : 'c-container'}`}
            onClick={() => !preview && handleShow()}
            style={{
              fontSize: `${fontSize}px`,
              color: color,
              textAlign: alignment,
              width: '100%'
            }}>
            {text || 'Click here to set title'}
          </div>

          <TextOffCanvas
            title="Content"
            show={show}
            initialValue={content}
            handleClose={handleClose}
            handleSave={handleSave}
            showDynamicValueOptions={true}
          />
        </>
      )}
    </>
  );
}

export default Content;
